export const translations = {
  en: {
    nav: {
      services: "Services",
      process: "Process",
      portfolio: "Builds",
      faq: "FAQ",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      overline: "One man, one workshop · Advice & system integration",
      title_l1: "Camper. Build.",
      title_l2: "Service.",
      subtitle:
        "In our workshop or mobile at your place.",
      cta_primary: "Send a message",
      cta_secondary: "What I do",
      stats: [
        { value: "1 : 1", label: "Advice, service & install" },
        { value: "Small", label: "Workshop, big heart" },
        { value: "Honest", label: "Timelines & prices" },
      ],
    },
    services: {
      overline: "What I do",
      title: "Advice. Install. Service.",
      subtitle_pre: "Bespoke cabinetry, ready-made furniture kits & integration of proven components into ",
      subtitle_em: "your",
      subtitle_post: " everyday camper.",
      subtitle_line2: "Only what you actually need.",
      subtitle:
        "Bespoke cabinetry, ready-made furniture kits & integration of proven components into your everyday camper. Only what you actually need.",
      items: {
        consultation: {
          name: "Advice & Planning",
          desc: "Come by, call, send me a message.. ideas, plans, budget.. I'll tell you what works, what's nonsense, and what's unnecessary. We talk and put together your individual, realistic quote.",
          tag: "Start here",
        },
        electrical: {
          name: "Electrical & Solar",
          desc: "LiFePO4 batteries, MPPT solar charge controllers, smart shunts, 230V inverters, lighting, USB outlets in every power class available. Calculated, tested, safe! And guaranteed at the same price you'd pay online.",
          tag: "Off-grid",
        },
        plumbing: {
          name: "Plumbing & Water",
          desc: "Suction and pressure pumps, water tanks, outdoor shower, faucets, sinks.. Clean install. Watertight. Easy to maintain.",
          tag: "Watertight",
        },
        heating: {
          name: "Heating Systems",
          desc: "Diesel and gas heaters from reputable manufacturers. Installed. Heat produced, exhaust gases vented. Tested, checked, approved, registered.",
          tag: "All-season",
        },
        furniture: {
          name: "Furniture Kits",
          desc: "Reimo, VanEssa, Vangear, CampBox, Comboing, Camp'n'Car, Schneckenhouse.. Why reinvent the wheel when proven, working solutions already exist on the market? I see myself as a system integrator here.. ;-)",
          tag: "Ready-made",
        },
        service: {
          name: "Service, Retrofits, Repairs · on-site or in the shop",
          desc: "In my workshop or mobile at your place, in winter storage, at the campsite, or in an emergency: upgrades, retrofits, cleaning, repairs and replacement of parts. All the small stuff that constantly needs doing on your travel companion. Short distances, honest prices.",
          tag: "Mobile · Stationary",
        },
      },
    },
    process: {
      overline: "How it works",
      title: "Six honest steps.",
      steps: [
        { n: "01", t: "First chat", d: "Phone, email or a coffee in the workshop. Tell me what you want." },
        { n: "02", t: "Planning", d: "We pick components and kits together. I send you links, you decide." },
        { n: "03", t: "Quote", d: "A clear, written quote. Fixed price for the labour. Parts at online price." },
        { n: "04", t: "Schedule", d: "We agree on a time window. You drop off the van, I get to work." },
        { n: "05", t: "Install", d: "During the install you get regular progress updates and stay in the loop the whole time. You can step in any time." },
        { n: "06", t: "Handover", d: "At handover you get complete documentation, the manuals for every component installed, and an introduction to operating your mobile home. You leave knowing your van." },
      ],
    },
    portfolio: {
      overline: "Recent work",
      title: "A few of the vans that left the shop.",
      subtitle: "Not glamour shots — honest jobs. Ask me about any of them.",
      view: "View build",
    },
    testimonials: {
      overline: "From other drivers",
      title: "What people say.",
      items: [
        {
          quote: "Cool guy.. our minimal \"van\" was ready in time and we had the best holiday with it!! Still a fully usable car for four people in everyday life.. and nothing was sold to us that we didn't need. Exactly how we hoped it would be :-)",
          name: "Antje F.",
          loc: "Gottmadingen · Dacia Logan I",
        },
        {
          quote: "An undersized solar setup now fits our actual needs. Finally off-grid! And that's still on the old AGM battery bank that another shop tried to make us replace.. Brilliant! ;-P",
          name: "Wiebke J.",
          loc: "Engen · Hymermobil",
        },
        {
          quote: "David got our second-hand caravan perfectly ready for a.. slightly longer trip. Power, water tank, new bike rack for our e-bikes.. And spotted and fixed a safety issue we hadn't even noticed. Thanks! :-)",
          name: "Max & Ronja",
          loc: "Konstanz · Hymer Eriba",
        },
      ],
    },
    faq: {
      overline: "Honest answers",
      title: "Probably what you want to know.",
      items: [
        {
          q: "Do you do full conversions from a bare van?",
          a: "In principle yes. That said, I currently take on custom-built furniture only on a limited basis. I see myself as an integrator of proven off-the-shelf products and a service provider for existing vehicles. But we can talk about pretty much anything.. ;-)",
        },
        {
          q: "Which furniture kits do you install?",
          a: "From a bolted-down folding sofa on the floor panel all the way to a full conversion with bath and shower.. Whatever you can think of and — if desired — qualifies for re-registration as a Sonder-Kfz / motor caravan. Prerequisite: it can be implemented safely and harms neither you, other road users, your passengers, nor the environment.",
        },
        {
          q: "TÜV and Wohnmobil registration?",
          a: "For my installs I follow the regulations and standards of the German TÜV Verband e.V. For the certification itself I work together with a local DEKRA inspector.",
        },
        {
          q: "Where are you, and can I just drop by?",
          a: "I'm either in my workshop in a small industrial estate in Volkertshausen, in my home office, or out on the road with a customer. Best to send a quick message or call first so we don't miss each other.",
        },
      ],
    },
    contact: {
      overline: "Get in touch",
      title: "Tell me about your van.",
      subtitle:
        "Tell me what you're up to. I'll get back to you as soon as my hands are clean.",
      fields: {
        name: "Your name",
        email: "Email",
        phone: "Phone (optional)",
        project: "What you're after",
        message: "A few words about your van and what you need",
      },
      project_options: [
        "Advice & Planning",
        "Electrical / Solar",
        "Plumbing / Water",
        "Heating system",
        "Furniture kit install",
        "Service / on-site / retrofit",
        "Just saying hi",
      ],
      submit: "Send message",
      sending: "Sending…",
      success: "Got it — thanks. I'll be in touch shortly.",
      error: "Something went wrong. Please try again or just send me an email.",
    },
    footer: {
      headline_l1: "Let's get your",
      headline_l2: "rig road-ready.",
      hours: "Mon–Fri · by appointment",
      address: "Buchstauden 16 · 78269 Volkertshausen (near Singen / Konstanz / Schaffhausen / border crossing Thayngen / southern end of motorway A81), Germany",
      rights: "alle Rechte vorbehalten.",
      built: "",
    },
    lang_toggle: { de: "DE", en: "EN" },
  },
  de: {
    nav: {
      services: "Leistungen",
      process: "Ablauf",
      portfolio: "Projekte",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Kontakt aufnehmen",
    },
    hero: {
      overline: "Ein Mann, eine Werkstatt · Beratung & Systemintegration",
      title_l1: "Camper. Ausbau.",
      title_l2: "Service.",
      subtitle:
        "In unserer Werkstatt oder mobil bei dir vor Ort.",
      cta_primary: "Nachricht schreiben",
      cta_secondary: "Was ich mache",
      stats: [
        { value: "1 : 1", label: "Beratung, Service & Einbau" },
        { value: "Kleine", label: "Werkstatt, großes Herz" },
        { value: "Ehrliche", label: "Termine & Preise" },
      ],
    },
    services: {
      overline: "Was ich mache",
      title: "Beratung. Einbau. Service.",
      subtitle_pre: "Individueller Möbelbau, fertige Möbelsets & Integration bewährter Komponenten in ",
      subtitle_em: "deinen",
      subtitle_post: " Alltagscamper.",
      subtitle_line2: "Nur was du wirklich brauchst.",
      subtitle:
        "Individueller Möbelbau, fertige Möbelsets & Integration bewährter Komponenten in deinen Alltagscamper. Nur was du wirklich brauchst.",
      items: {
        consultation: {
          name: "Beratung & Planung",
          desc: "Komm vorbei, ruf an, schreib mir eine Nachricht.. Ideen, Pläne, Budget.. Ich sage dir was funktioniert, was Quatsch ist und was unnötig. Wir quatschen und erarbeiten dein individuelles, realistisches Angebot.",
          tag: "Hier starten",
        },
        electrical: {
          name: "Elektrik & Solar",
          desc: "LiFePo4 Batterien, MPPT Solarladeregler, Smart-Shunt, 230V Wechselrichter, Beleuchtung, USB-Steckdosen in allen verfügbaren Leistungsklassen. Gerechnet, geprüft, sicher! Und garantiert zum selben Preis, den du online auch bezahlen würdest.",
          tag: "Autark",
        },
        plumbing: {
          name: "Sanitär & Wasser",
          desc: "Saug- und Druckpumpen, Wassertanks, Außendusche, Armaturen, Waschbecken.. Saubere Installation. Dicht. Einfach zu warten.",
          tag: "Dicht",
        },
        heating: {
          name: "Heizsysteme",
          desc: "Diesel- und Gasheizungen namhafter Hersteller. Eingebaut. Wärme erzeugt, Abgase abgeführt. Getestet, geprüft, abgenommen, eingetragen.",
          tag: "Ganzjährig",
        },
        furniture: {
          name: "Möbel-Sets",
          desc: "Reimo, VanEssa, Vangear, CampBox, Comboing, Camp´n´Car, Schneckenhouse.. Warum das Rad neu erfinden, wenn es funktionierende & erprobte Lösungen am Markt bereits gibt? Ich verstehe mich hier als System-Integrator.. ;-)",
          tag: "Bewährt",
        },
        service: {
          name: "Service, Nachrüstungen, Reparaturen · stationär oder mobil",
          desc: "In meiner Werkstatt oder mobil bei dir vor Ort, im Winterlager oder am Campingplatz und im Notfall: Aufrüstungen, Nachrüstungen, Reinigung und Reparaturen und Austausch von Teilen. Der ganze Kleinkram, der ständig und immer wieder an deinem Begleiter zu tun ist. Kurze Wege, ehrliche Preise.",
          tag: "Mobil · Stationär",
        },
      },
    },
    process: {
      overline: "So läuft´s",
      title: "Sechs ehrliche Schritte.",
      steps: [
        { n: "01", t: "Erstgespräch", d: "Telefon, Mail oder ein Kaffee in der Halle. Erzähl mir, was du willst." },
        { n: "02", t: "Planung", d: "Wir wählen Komponenten und Sets gemeinsam aus. Ich schicke dir Links, du entscheidest." },
        { n: "03", t: "Angebot", d: "Ein klares schriftliches Angebot. Festpreis für die Arbeit. Teile zum Onlinepreis." },
        { n: "04", t: "Termin", d: "Wir vereinbaren einen Zeitraum. Du bringst den Van vorbei, ich lege los." },
        { n: "05", t: "Einbau", d: "Während des Einbaus bekommst du regelmäßig Updates zum Fortschritt und bist so stetig auf dem Laufenden. Und du kannst jederzeit intervenieren." },
        { n: "06", t: "Übergabe", d: "Bei der Übergabe bekommst du eine komplette Dokumentation sowie die Bedienungsanleitungen aller eingebauten Komponenten und eine Einführung in die Bedienung deines mobilen Zuhauses. Du fährst los und kennst deinen Van." },
      ],
    },
    portfolio: {
      overline: "Aktuelle Projekte",
      title: "Ein paar Vans, die hier waren.",
      subtitle: "Keine Hochglanzfotos – ehrliche Arbeit. Frag mich gern zu jedem Projekt.",
      view: "Projekt ansehen",
    },
    testimonials: {
      overline: "Von anderen Fahrern",
      title: "Was Leute sagen.",
      items: [
        {
          quote: "Geiler Typ.. unser minimal \"Van\" war in time fertig und wir hatten den besten Urlaub damit!! Im Alltag zu viert immer noch absolut brauchbares Auto.. und aufgeschwatzt wurde uns auch nichts. So haben wir uns das vorgestellt :-)",
          name: "Antje F.",
          loc: "Gottmadingen · Dacia Logan I",
        },
        {
          quote: "Zu kleine Solaranlage jetzt passend für unseren Bedarf. Endlich autark! Und das noch mit der alten AGM-Batteriebank, die man uns woanders schon unleidig machen wollte.. Hammer! ;-P",
          name: "Wiebke J.",
          loc: "Engen · Hymermobil",
        },
        {
          quote: "Unseren neuen gebrauchten Wohnwagen hat David perfekt auf einen.. etwas längeren Trip vorbereitet. Strom, Wassertank, neuer Fahrradträger für unsere eBikes.. Und ein uns bis dahin unbekanntes Sicherheitsproblem entdeckt und beseitigt.. Danke! :-)",
          name: "Max und Ronja",
          loc: "Konstanz · Hymer Eriba",
        },
      ],
    },
    faq: {
      overline: "Ehrliche Antworten",
      title: "Was du wahrscheinlich wissen willst.",
      items: [
        {
          q: "Machst du auch Komplettausbauten aus einem leeren Van?",
          a: "Grundsätzlich ja. Allerdings mache ich individuelle Möbel im Moment nur in begrenztem Umfang. Ich verstehe mich als Integrator von am Markt erhältlichen fertigen Produkten und deren Montage und als Servicedienstleister an existierenden Fahrzeugen. Aber wir können grundsätzlich über alles sprechen.. ;-)",
        },
        {
          q: "Welche Möbel-Sets baust du ein?",
          a: "Vom angespaxten Klappsofa auf der Bodenplatte bis hin zum Komplettausbau mit Bad und Dusche.. Alles was dir einfällt und was, wenn gewünscht, zur Ummeldung als Sonder-Kfz Wohnmobil geeignet ist. Voraussetzung: es lässt sich sicher umsetzen und schadet weder dir, noch anderen Verkehrsteilnehmern, Mitreisenden oder der Umwelt.",
        },
        {
          q: "TÜV und Wohnmobil-Eintragung?",
          a: "Ich richte mich bei meinen Einbauten nach den Bestimmungen und Vorschriften des deutschen TÜV Verband e.V. Zur Abnahme arbeite ich des Weiteren mit einem örtlichen Prüf-Ingenieur der DEKRA zusammen.",
        },
        {
          q: "Wo bist du und kann ich einfach vorbeikommen?",
          a: "Ich bin in meiner Werkstatt in einem kleinen Industriegebiet in Volkertshausen, im Homeoffice oder tatsächlich unterwegs beim Kunden. Schick mir am besten kurz eine Nachricht oder ruf kurz an, damit wir uns nicht verpassen.",
        },
      ],
    },
    contact: {
      overline: "Schreib mir",
      title: "Erzähl mir von deinem Van.",
      subtitle:
        "Schreib mir was du vorhast. Ich melde mich zurück, sobald die Hände sauber sind.",
      fields: {
        name: "Dein Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        project: "Worum geht's?",
        message: "Ein paar Worte zu deinem Van und was du brauchst",
      },
      project_options: [
        "Beratung & Planung",
        "Elektrik / Solar",
        "Sanitär / Wasser",
        "Heizsystem",
        "Möbel-Set Einbau",
        "Service / Vor-Ort / Nachrüstung",
        "Einfach mal Hallo sagen",
      ],
      submit: "Nachricht senden",
      sending: "Wird gesendet…",
      success: "Angekommen – danke. Ich melde mich in Kürze.",
      error: "Etwas ist schiefgelaufen. Bitte nochmal versuchen oder schick mir direkt eine E-Mail.",
    },
    footer: {
      headline_l1: "Lass uns deine",
      headline_l2: "Karre reisefertig machen.",
      hours: "Mo–Fr · nach Vereinbarung",
      address: "Buchstauden 16 · 78269 Volkertshausen (bei Singen / Konstanz / Schaffhausen / Grenzübergang Thayngen / südliches Ende der Autobahn A81)",
      rights: "alle Rechte vorbehalten.",
      built: "",
    },
    lang_toggle: { de: "DE", en: "EN" },
  },
};
